import React from "react";

import "../../../style/loading-indicators.less";

/**
 * Loading indicator
 * @returns
 */
function LoadingIndicator() {
  // do not use translations here!
  return (
    <div className="ek-loading-indicator">
      <div className="ek-loading-indicator-icon">
        <span className="fa fa-fw fa-spinner fa-spin fa-pulse" />
      </div>
    </div>
  );
}

export default LoadingIndicator;
